import React from 'react'

import classNames from 'classnames'

import { isString } from '@local/utils'

import { ClickHandler } from '@web/types'

import Clickable from '../Clickable'
import styles from './ContextMenu.module.scss'

export interface MenuItemProps {
  clickCode?: string
  clickHandler?: ClickHandler
  hide?: () => void
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
  label: string | React.ReactNode
  subLabel?: string | React.ReactNode
  visibility?: boolean
}

const MenuItem = ({ clickCode, clickHandler, hide, icon, label, subLabel }: MenuItemProps) => {
  return isString(label) ? (
    <Clickable
      key={label}
      className={classNames(styles.btn, { [styles.has_icon]: icon })}
      onClick={e => {
        if (hide) {
          hide()
        }

        if (clickHandler) {
          clickHandler(e)
        }
      }}
      nClickCode={clickCode || undefined}
    >
      {label}
      {icon &&
        React.createElement(icon, {
          className: styles.icon,
          role: 'presentation',
        })}
      {subLabel}
    </Clickable>
  ) : (
    <div className={styles.btn}>
      {label}
      {icon &&
        React.createElement(icon, {
          className: styles.icon,
          role: 'presentation',
        })}
      {subLabel}
    </div>
  )
}

export default MenuItem
